"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _source = require("./source");
Object.keys(_source).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _source[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _source[key];
    }
  });
});